import { Paper } from "@mui/material";
import Card from "components/Dashboard/Card";

export default function OwnerData(props) {
  const t = props.estatedProperty;
  const data = {
    "Owner Name(s)": t.owners.length ? t.owners[0].name : undefined,
    "Mailing Address": t.owners.length ? `${t.owners[0].placeName}` : undefined,
    "Email Address": "TODO",
    "Phone Number": "TODO",
    "Number of properties in DB with same name": "TODO",
  };
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Card label="Owner Data" activeKey="owner_data" row={data} />
    </Paper>
  );
}
